import { FCX } from "@datassential/platform-ui-lib";
import { ComponentProps, ReactNode } from "react";
import cn from "classnames";

type Modifier = 'transparent' | 'active' | 'default-width' | 'min-width' | 'label-right';

const Field: FCX<{
    label?: ReactNode;
    modifiers?: Modifier[];
    withoutBox?: boolean;
}> = ({
    label,
    modifiers = [],
    withoutBox = false,
    className,
    testId,
    children,
    ...props
}) => {
    return (
        <div
            className={cn(
                "Field",
                className,
                ...modifiers.map(modifier => `is-${modifier}`),
            )}
            data-testid={testId}
            {...props}
        >
            {!!label && (
                <label className="Field__label">
                    {label}
                </label>
            )}
            {withoutBox ? children : (
                <div className="Field__box">
                    {children}
                </div>
            )}
        </div>
    );
};

export type FieldProps = ComponentProps<typeof Field>;

export default Field;